var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var Header = function(el) {
  var t = this,
      $body = $( 'body');

  this.$el = $(el);
  this.$bar = this.$el.children( ".header-bar" );
  this.$search  = this.$el.find( ".search-bar" );
  this.$searchField = this.$search.find( ".search-field" );
  this.$searchToggle = this.$el.find( ".header-search-toggle" );

  this.$el.on('click', '.global-nav *', function(event) {
    event.stopPropagation();
  }).find('.header-menu-toggle').on('click', function() {
    $body.toggleClass('show-menu');
    $body.removeClass( "js-search-bar-active" );
  }.bind(this));

  $body.on('click', function(event) {
    if ( !$( event.target ).closest( ".search-bar").length ) {
      $body.removeClass('show-menu');
    }
  });

  this.$searchField.on( "focus", function() {
    t.$search.addClass( "js-focused" );
  });

  this.$searchField.on( "blur", function() {
    t.$search.removeClass( "js-focused" );
  });

  this.$searchToggle.on( "click", function() {
    $body.removeClass( "show-menu" );
    $body.toggleClass( "js-search-bar-active" );
    if ( $body.hasClass( "js-search-bar-active" ) ) {
      t.$searchField.focus();
    }
  });

  this.initBackground();
};

Header.prototype = {
  initBackground: function() {
    this.$bgWrap = this.$el.find('.header-menu-background');
    this.$bg = this.$el.find('.header-menu-background-inner');
    this.$bgImg = this.$el.find('.header-menu-background-image');

    $(window).on('vsc-page-ready vsc-page-resized', function() {
      this.$bgImg.css('height', this.$bgWrap.outerHeight()+'px');
    }.bind(this));

    this.$el.on('mouseover', '.header-menu-primary li', function(event) {
      var $li = $(event.currentTarget);

      this.$bg.css({
        'height': $li.outerHeight()+'px',
        'transform': 'translateY('+($li.position().top+20)+'px)'
      });

      this.$bgImg.css({
        'transform': 'translateY(-'+($li.position().top+20)+'px)'
      });
    }.bind(this));

    this.$el.on('mouseout', '.header-menu-primary', function(event) {
      this.$bg.css({
        'height': 0
      });
    }.bind(this));
  }
}

module.exports = Header;
